/* eslint-disable indent */
<template>
    <div class="winner-and-placement">
        <div class="number--award">
            <div class="a-vg-c--ont" :class="extractClassForDogPosition(dogPosition)">
                <span>{{place}}</span>
                <img :src="awardImage(awardPlace)" :alt="awardAltTag(awardPlace)" />
            </div>
        </div>
        <div class="result-description winner-position">
            <h5>
                {{$t('vdog_winner')}}
                {{format(extractStakeForDog(0))}}
            </h5>
            <div class="other-results">
                <p>
                    ({{$t('vdog_in_first_2')}})
                    <span>{{format(extractStakeForDog(1))}}</span>
                </p>
                <p>
                    ({{$t('vdog_in_first_3')}})
                    <span>{{format(extractStakeForDog(2))}}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import VDogHelper from '@/mixins/VDogHelper'
import LanguageHelper from '@/mixins/LanguageHelper'

export default {
  mixins: [NumberFormat, VDogHelper, LanguageHelper],
  props: {
    image: {
      type: String,
      default: ''
    },
    awardPlace: {
      type: Number,
      required: true
    },
    place: {
      type: Number,
      required: true
    },
    match: {
      type: Object,
      required: true
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers())
    },
    extractStakeForDog (type) {
      if (this.match && this.match.winnerInFirstTable &&
      this.match.winnerInFirstTable.data &&
      this.match.winnerInFirstTable.data[this.dogPosition] &&
      this.match.winnerInFirstTable.data[this.dogPosition][type]) {
        return this.match.winnerInFirstTable.data[this.dogPosition][type].Factor
      }
    }
  },
  computed: {
    dogPosition: function () {
      return this.place - 1
    }
  }
}
</script>
